/** @format */ import React, { useContext, useEffect, useState } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import { Controller, useForm, FormProvider } from "react-hook-form";
import Link from "@mui/material/Link";
import MailIcon from "@mui/icons-material/MailOutline";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import { styled } from "@mui/material/styles";
import { Amplify } from "aws-amplify";
import { Auth } from "aws-amplify";
import FooterComponent from "../components/Footer";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import TooltipComponent from "../components/common/Tooltip";
import "./Login.css";
import Checkbox from "@mui/material/Checkbox";
import { setupAuthInterceptor } from "../utils/apis";
import { OAuthCtx } from "../auth/AuthContext";
import {
  Alert,
  Button,
  Container,
  Divider,
  IconButton,
  InputAdornment,
  FormLabel,
} from "@mui/material";
import {
  userLogin,
  googleUserLogin,
} from "../components/stepper_form/stepper.helper";
import { useFeatureFlag } from "@harnessio/ff-react-client-sdk";
import { setUserStatus } from "../redux/action/user";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import DataDecryption from "../components/common/DataDecryption";
import { useMediaQuery, makeStyles } from "@mui/material";
import {
  getCountryCode,
  getRedirectSignInURL,
  getRedirectSignOutURL,
} from "../components/common/GlobalFunction";
import {
  getEmail,
  saveToSessionStorage,
  saveTargetPath,
} from "../utils/storage";
import Loading from "../components/UI/Loading";
import { Helmet } from "react-helmet";
// Import the configuration
import "../utils/amplifyConfig";
import { LinkedIn } from "@mui/icons-material";
import {
  SHOW_GOOGLE_LOGIN_BUTTON,
  SHOW_LINKEDIN_LOGIN_BUTTON,
} from "../components/common/GlobalVariable";
import { truncate } from "lodash";
import LoadingPage from "../components/UI/Loading";
// import { setIncognitoMode } from "../redux/action/IncognitoMode";
import { Icon } from "@iconify-icon/react";
import InfoIcon from "@mui/icons-material/Info";
import EmailIcon from "@mui/icons-material/Email";
import { motion } from "framer-motion";
import CircularProgress from "@mui/material/CircularProgress";

export default function Login() {
  const { setAuthState } = useContext(OAuthCtx);
  const { getAuthState } = useContext(OAuthCtx);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const staticRandomEncodeDecodeString = useFeatureFlag(
    "staticRandomEncodeDecodeString"
  );
  const secretEncodeDecodeString = useFeatureFlag("secretEncodeDecodeString");
  const isLoggedIn =
    sessionStorage.getItem("isLoggedIn") === "true" ? true : false;
  const urlSearchString = window.location.search;
  const params = new URLSearchParams(urlSearchString);
  const uniqueReferredUserId = params.get("ref");
  const showLinkedInButton = useFeatureFlag(SHOW_LINKEDIN_LOGIN_BUTTON);
  const showGoogleButton = useFeatureFlag(SHOW_GOOGLE_LOGIN_BUTTON);
  const userType = params.get("link-type") || "copy-link";
  const referBy = params.get("referby") || params.get("referBy");
  const [deviceInfo, setDeviceInfo] = React.useState();
  const userEmail = getEmail();
  const [LoginButtonShow, setLoginButtonShow] = React.useState(true);
  const [viewAsRecruiter, setViewAsRecruiter] = React.useState(false);

  const {
    control,
    handleSubmit,
    setError,
    getValues,
    watch,
    formState: { errors },
    reset,
  } = useForm();
  let EnteredEmail = watch("email") || "";
  const isMobile = useMediaQuery("(max-width:600px)");

  const AllowDomains = useFeatureFlag("AllowDomainsOnly");
  const EMAIL_GHOST_TEXT = `${
    isMobile ? "Enter Email" : "Enter your personal email id"
  }`;
  const OTP_GHOST_TEXT = `Enter the OTP`;
  const OTP_ERROR_MSG = `Oh no, that doesn't look like a valid OTP! Please double-check and enter the OTP sent to ${getValues(
    "email"
  )}.`;

  const [errorHandler, setErrorHandler] = React.useState({
    error: 0,
    errorMsg: "",
  });
  const [cognitoUserstate, setCognitoUserstate] = React.useState();
  const [showOTPForm, setShowOTPForm] = React.useState(false);
  const Img = styled("img")({
    objectFit: "cover",
    width: "100%",
    height: "auto",
  });
  const [agreementCheck, setAgreementCheck] = React.useState(false);
  // const [IncognitoModeStatus, setIncognitoModeStatus] = React.useState(false);
  const [showEmailField, setShowEmailField] = useState(false);
  const [loadingButton, setLoadingButton] = React.useState(false);
  const [domainList, setDomainList] = React.useState([
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "aol.com",
    "msn.com",
    "comcast.net",
    "yahoo.co.in",
    "live.com",
    "rediffmail.com",
    "ymail.com",
    "outlook.com",
    "googlemail.com",
    "rocketmail.com",
    "facebook.com",
    "yahoo.in",
    "me.com",
    "mail.com",
  ]);

  //  check user entered email or not with term & service
  useEffect(() => {
    if (EnteredEmail.length > 0) {
      if (agreementCheck) {
        setLoginButtonShow(false);
      } else {
        setLoginButtonShow(true);
      }
    } else {
      setLoginButtonShow(true);
    }
  }, [EnteredEmail, agreementCheck]);

  //dispatch event for Incognito mode
  // useEffect(() => {
  //   if (IncognitoModeStatus) {
  //     localStorage.setItem("IncognitoUser", true);
  //     dispatch(setIncognitoMode(true));
  //   } else {
  //     localStorage.setItem("IncognitoUser", false);
  //     dispatch(setIncognitoMode(false));
  //   }
  // }, [IncognitoModeStatus]);

  function getRandomString(bytes) {
    const randomValues = new Uint8Array(bytes);
    window.crypto.getRandomValues(randomValues);
    return Array.from(randomValues).map(intToHex).join("");
  }
  function intToHex(nr) {
    return nr.toString(16).padStart(2, "0");
  }
  //Login with register
  const handleSubmitCustom = async (data) => {
    let email = data.email.toLowerCase();
    setLoadingButton(true);
    var idx1 = email.indexOf("@");
    if (AllowDomains) {
      if (idx1 > -1) {
        var splitStr = email.split("@");
        var splitStr1 = splitStr[1].split(".");
        var jointSplitStr = "." + splitStr1[1];

        if (domainList?.indexOf(splitStr[1]) < 0) {
          if (domainList?.indexOf(jointSplitStr) < 0) {
            setError("email", {
              type: "validomain",
              message: `Enter email with one of the allowed domains: ${domainList.join(
                ", "
              )}`,
            });
            setLoadingButton(false);
            return;
          }
        }
      }
    }

    const params = {
      username: email,
      password: getRandomString(30),
      attributes: {
        email: email,
      },
    };
    var respons = [];

    try {
      //Check and user add user
      respons = await Auth.signUp(params);
      setShowEmailField(true);
      setShowOtp(true);
      setHeaderText("Enter The OTP");
      setLoadingButton(false);
    } catch (error) {
      if (error.message == "User already exists") {
        try {
          const cognitoUser = await Auth.signIn(email);
          setCognitoUserstate(cognitoUser);
          setShowOTPForm(true);
          const cstmError = { error: 0, errorMsg: "" };
          setLoadingButton(false);
          setErrorHandler(cstmError);
          localStorage.setItem("userEmail", cognitoUser.username);
        } catch (error) {
          const cstmError = { error: 1, errorMsg: error.message };
          setErrorHandler(cstmError);
          setLoadingButton(false);
        }
      } else {
        const cstmError = { error: 1, errorMsg: error.message };
        setErrorHandler(cstmError);
        setLoadingButton(false);
      }
    }
    if (respons.userConfirmed == true) {
      try {
        const cognitoUser = await Auth.signIn(email);
        setCognitoUserstate(cognitoUser);
        setShowOTPForm(true);

        const cstmError = { error: 0, errorMsg: "" };
        setErrorHandler(cstmError);
        localStorage.setItem("userEmail", cognitoUser.username);
        setLoadingButton(false);
      } catch (error) {
        const cstmError = { error: 1, errorMsg: error.message };
        setErrorHandler(cstmError);
        setLoadingButton(false);
      }
    }
  };

  const handleOTPSubmit = async (data) => {
    setLoadingButton(true);
    let otp = data.otp;
    let cognitoUser = {};
    try {
      cognitoUser = await Auth.sendCustomChallengeAnswer(cognitoUserstate, otp);
      if (cognitoUser.challengeName == "CUSTOM_CHALLENGE") {
        setError("otp", {
          type: "notvalid",
          message: "OTP is not valid please again!",
        });
      }
      try {
        var currentSession = null;
        currentSession = await Auth.currentSession();
        await setAuthState(currentSession);
        setupAuthInterceptor(getAuthState);

        const payload = {
          email: cognitoUser.username,
          registerTime: new Date(Date.now()).toUTCString(),
          lastLoginTime: new Date(Date.now()).toUTCString(),
          termsCondition: true,
          uniqueReferredUserId: params.get("ref"),
          type: userType,
          referBy: referBy,
          referTime: new Date(Date.now()).toUTCString(),
        };
        dispatch(setUserStatus({ loading: true }));
        await userLogin(payload, navigate, dispatch, setUserStatus);
      } catch (e) {
        setError("otp", {
          type: "notvalid",
          message: "OTP is not valid please again!",
        });
        setLoadingButton(false);
      }
    } catch (e) {
      setError("otp", {
        type: "NotAuthorizedException",
        message:
          "The OTP you have entered is invalid, and you have reached the maximum number of attempts allowed to enter it. Please return to the Sign In page and try again.",
      });
      setLoadingButton(false);
    }
  };

  async function getAllowDomains() {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + "/get-emailBlackListDomain",
        {
          options: {
            type: "json",
          },
        }
      );

      if (!response || !response.data) {
        console.error("API response is empty or invalid:", response);
        return;
      }

      const decryptedData = DataDecryption(
        response.data,
        staticRandomEncodeDecodeString,
        secretEncodeDecodeString
      );

      if (
        !decryptedData ||
        !decryptedData.emailDomainList ||
        !decryptedData.emailDomainList[0] ||
        !decryptedData.emailDomainList[0].domains
      ) {
        console.error("Invalid decrypted data structure:", decryptedData);
        return;
      }

      setDomainList(decryptedData.emailDomainList[0].domains);
    } catch (error) {
      console.error("Error fetching email domain list:", error);
    }
  }

  const [loading, setLoading] = useState(false);
  const [isAllowed, setIsAllowed] = React.useState(true);
  const Allowed_Countries = useFeatureFlag("Allowed_Countries");
  let Allowed_Countries_JSON = [];
  try {
    Allowed_Countries_JSON = Allowed_Countries
      ? JSON.parse(Allowed_Countries)
      : [];
  } catch (error) {
    console.error("Invalid JSON in Allowed_Countries:", error);
    Allowed_Countries_JSON = [];
  }
  let allowedCountriesArray = [];
  try {
    allowedCountriesArray = JSON.parse(Allowed_Countries_JSON);
  } catch (error) {
    console.error("Failed to parse Allowed_Countries_JSON:", error);
  }

  // Format allowed countries into a readable sentence
  const allowedCountries = allowedCountriesArray
    .join(", ")
    .replace(/,([^,]*)$/, " and$1");

  useEffect(() => {
    getAllowDomains();
  }, []);

  const domains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "aol.com",
    "msn.com",
    "comcast.net",
    "yahoo.co.in",
    "live.com",
    "rediffmail.com",
    "ymail.com",
    "outlook.com",
    "googlemail.com",
    "rocketmail.com",
    "facebook.com",
    "yahoo.in",
    "me.com",
    "mail.com",
    "trueselfy.com",
  ];
  const showDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "aol.com",
    "msn.com",
    "comcast.net",
    "yahoo.co.in",
    "live.com",
    "rediffmail.com",
    "ymail.com",
    "outlook.com",
    "googlemail.com",
    "rocketmail.com",
    "facebook.com",
    "yahoo.in",
    "me.com",
    "mail.com",
  ];

  const [isChecked, setIsChecked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showEmail, setShowEmail] = useState();
  const [disableBtn, setDisableBtn] = useState(false);
  const [headerText, setHeaderText] = useState("Sign In With");
  const [showOtp, setShowOtp] = useState(false);
  const methods = useForm({ criteriaMode: "all" });

  const handleEmailButtonClick = () => {
    if (!isChecked) {
      setErrorMessage("Please agree to the Terms of Service & Privacy Policy");
      return;
    }
    setShowEmail(true);
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(!isChecked);
    setAgreementCheck(!agreementCheck);
    // Clear error message when user checks the checkbox
    if (event.target.checked) {
      setErrorMessage("");
    }
  };
  // const handleIncognitoChange = (event) => {
  //   setIncognitoModeStatus(!IncognitoModeStatus);
  // };

  return (
    <>
      <Helmet>
        <title>
          Future Pay Scale Prediction Calculator Tool Online | Endorse My
          Expertise
        </title>
        <meta
          name="description"
          content="Boost my professional standing and assist in determining my rightful pay scale! Only 2 minutes of your time can make a significant impact. Your endorsement means a lot!"
        />
        <meta
          property="og:title"
          content="Future Pay Scale Prediction Calculator Tool Online | Endorse My Expertise"
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:description"
          content="Boost my professional standing and assist in determining my rightful pay scale! Only 2 minutes of your time can make a significant impact. Your endorsement means a lot!"
        />
        <meta
          property="og:url"
          content="https://master.d3hqz1cwjn0bmv.amplifyapp.com/signin"
        />
      </Helmet>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            width: "100%",
            backgroundImage:
              "url('../../assets/images/homepage-background.svg')",
          }}
          position="fixed"
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              width: "100%",
              backgroundImage:
                "url('../../assets/images/homepage-background.svg')",
            }}
            position="fixed"
          >
            {isAllowed ? (
              <Grid
                container
                spacing={0}
                sx={{
                  width: "100%",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: showOTPForm ? "top" : "center",
                }}
              >
                <Grid
                  item
                  xs={0}
                  md={0}
                  lg={6}
                  sx={{
                    display: { xs: "none", md: "none", lg: "block" },
                  }}
                >
                  <Box sx={{ py: "80px", height: "100vh" }}>
                    <Box
                      sx={{
                        width: "100%",
                        height: "inherit",
                      }}
                    >
                      <Box
                        component="img"
                        sx={{
                          width: "100%",
                          height: "100%",
                        }}
                        alt="Login"
                        src="/assets/images/login-vector.svg"
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={6}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100vh",
                      width: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        pb: 3,
                        width: "100%",
                        textAlign: {
                          xs: "center",
                          md: "center",
                          lg: "center",
                        },
                      }}
                    >
                      <a href="/">
                        <img
                          src={"../../assets/images/TrueSelfy-logo(White).svg"}
                          alt="true-selfy"
                          loading="lazy"
                          style={{
                            maxWidth: `${isMobile ? "80px" : ""}`,
                          }}
                        />
                      </a>
                    </Box>
                    {showOTPForm == false ? (
                      <Box
                        sx={{
                          borderRadius: "20px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: {
                            xs: "center",
                            md: "center",
                            lg: "center",
                          },
                          maxWidth: { xs: 281, sm: 499 },
                          width: "100%",
                          backgroundColor: "#231F20",
                          color: "#FDF9E0",
                          margin: "0 auto",
                          p: { xs: "16px", md: "30px" },
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: { xs: "30px", md: "55px" },
                            fontWeight: { xs: 600, md: 700 },
                            lineHeight: { xs: "40px", md: "65px" },
                            fontFamily: "Kanit",
                            mb: { xs: "20px", lg: "41px" },
                          }}
                          textAlign={"center"}
                        >
                          Sign In
                        </Typography>
                        <Grid container gap={2} justifyContent="center">
                          {!showEmail ? (
                            <>
                              <Grid item xs={10} textAlign={"center"}>
                                <Box
                                  alignItems={"center"}
                                  display="flex"
                                  sx={{
                                    cursor: "pointer",
                                    justifyContent: "center",
                                  }}
                                >
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        size="small"
                                        sx={{ color: "#FDF9E0" }}
                                        checked={isChecked}
                                        onChange={handleCheckboxChange}
                                      />
                                    }
                                    label={
                                      <Typography variant="body2">
                                        I agree to the
                                        <Link
                                          href="https://vucaware.com/terms-and-conditions/"
                                          // target="_blank"
                                          sx={{
                                            marginLeft: 0.5,
                                            marginRight: 0.5,
                                          }}
                                        >
                                          Terms of Service
                                        </Link>
                                        &
                                        <Link
                                          href="https://vucaware.com/privacy-policy/"
                                          // target="_blank"
                                          sx={{ marginLeft: 0.5 }}
                                        >
                                          Privacy Policy
                                        </Link>
                                      </Typography>
                                    }
                                  />
                                </Box>
                              </Grid>
                              {showGoogleButton && (
                                <Grid item xs={10}>
                                  <Button
                                    variant="text"
                                    fullWidth
                                    sx={{
                                      display: "flex",
                                      gap: 1,
                                      px: 3,
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: { xs: "6px", md: "20px" },
                                      color: "#FDF9E0",
                                      fontSize: { xs: "15px", md: "24px" },
                                      fontWeight: 500,
                                      border: "1px solid #878787",
                                      textTransform: "unset",
                                      "&:hover,&:focus": {
                                        border: "2px solid #26801E",
                                      },
                                    }}
                                    disabled={disableBtn}
                                    onClick={async () => {
                                      try {
                                        if (!isChecked) {
                                          setErrorMessage(
                                            "Please agree to the Terms of Service & Privacy Policy"
                                          );
                                          return;
                                        }
                                        await Auth.federatedSignIn({
                                          provider: "Google",
                                        });
                                      } catch (error) {
                                        console.error(
                                          "Error during Google federated sign-in or attribute update",
                                          error
                                        );
                                      }
                                    }}
                                  >
                                    <img
                                      src="../../../assets/images/google-logo.png"
                                      style={{
                                        maxWidth: "36px",
                                      }}
                                      loading="lazy"
                                      height="auto"
                                      alt="google-logo"
                                    />{" "}
                                    Google
                                  </Button>
                                </Grid>
                              )}

                              {showLinkedInButton && (
                                <Grid item xs={10}>
                                  <Button
                                    variant="text"
                                    fullWidth
                                    sx={{
                                      display: "flex",
                                      gap: 1,
                                      px: 3,
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: { xs: "6px", md: "20px" },
                                      color: "#FDF9E0",
                                      fontSize: { xs: "15px", md: "24px" },
                                      fontWeight: 500,
                                      border: "1px solid #878787",
                                      textTransform: "unset",

                                      "&:hover,&:focus": {
                                        border: "2px solid #007BB5",
                                        background: "rgba(0,123,181,0.04)",
                                      },
                                    }}
                                    disabled={disableBtn}
                                    onClick={async () => {
                                      try {
                                        if (!isChecked) {
                                          setErrorMessage(
                                            "Please agree to the Terms of Service & Privacy Policy"
                                          );
                                          return;
                                        }
                                        sessionStorage.setItem(
                                          "clickedSocialMediaLogin",
                                          true
                                        );
                                        await Auth.federatedSignIn({
                                          provider: "LinkedIn",
                                        });
                                      } catch (error) {
                                        console.error(
                                          "Error during LinkedIn federated sign-in or attribute update",
                                          error
                                        );
                                      }
                                    }}
                                  >
                                    <img
                                      src="../../../assets/images/linkedin-square.png"
                                      style={{
                                        maxWidth: "36px",
                                        borderRadius: "5px",
                                      }}
                                      loading="lazy"
                                      height="auto"
                                      alt="google-logo"
                                    />{" "}
                                    Linkedin
                                  </Button>
                                </Grid>
                              )}
                              <Grid item xs={10}>
                                <Box>
                                  <Button
                                    variant="text"
                                    sx={{
                                      border: "1px solid #878787",
                                      color: "#FDF9E0",
                                      borderRadius: { xs: "6px", md: "20px" },
                                      textTransform: "unset",
                                      fontSize: { xs: "15px", md: "24px" },
                                      "&:hover,&:focus": {
                                        border: "2px solid rgb(30, 26, 20)",
                                      },
                                    }}
                                    onClick={handleEmailButtonClick}
                                    fullWidth
                                  >
                                    <EmailIcon fontSize="large" />
                                    &nbsp;Email
                                  </Button>
                                </Box>
                              </Grid>
                            </>
                          ) : showOtp ? (
                            <>
                              <motion.div>
                                <Grid
                                  container
                                  justifyContent={"center"}
                                  component="form"
                                  id="otp-form"
                                  onSubmit={handleSubmit(handleOTPSubmit)}
                                >
                                  <Grid item xs={12} sm={12}>
                                    <Alert
                                      icon={false}
                                      severity="success"
                                      sx={{
                                        justifyContent: "center",
                                        textAlign: "center",
                                        mb: "20px",
                                      }}
                                    >
                                      {/* Received in the email sent to your email id */}
                                      {`We’ve sent a verification code to your email`}
                                      <Typography
                                        sx={{
                                          textAlign: "center",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          maxWidth: "300px",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {userEmail}
                                      </Typography>
                                    </Alert>
                                    <Controller
                                      name="otp"
                                      control={control}
                                      rules={{
                                        required: "OTP is required",
                                        pattern: {
                                          value: /^[0-9]+$/,
                                          message: OTP_ERROR_MSG,
                                        },
                                      }}
                                      render={({ field }) => (
                                        <TextField
                                          {...field}
                                          size={"small"}
                                          sx={{
                                            "& .MuiInputBase-root": {
                                              borderRadius: {
                                                xs: "22px",
                                                lg: "55px !important",
                                              },
                                            },
                                            "& input[type=number]": {
                                              "-moz-appearance": "textfield",
                                              // Disable spin buttons in Chrome, Safari, Edge
                                              "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                                                {
                                                  WebkitAppearance: "none",
                                                  margin: 0,
                                                },
                                            },
                                          }}
                                          error={errors?.otp ? true : false}
                                          fullWidth
                                          id="otp"
                                          type="number"
                                          label={`Enter the OTP`}
                                          helperText={
                                            <>
                                              {errors?.otp &&
                                                errors?.otp.message}
                                            </>
                                          }
                                        />
                                      )}
                                    />
                                  </Grid>
                                  <Grid item xs={10} sm={12}>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        py: 2,
                                      }}
                                    >
                                      <LoadingButton
                                        type="submit"
                                        form={"otp-form"}
                                        variant="contained"
                                        sx={{
                                          borderRadius: "55px",
                                        }}
                                        loading={loadingButton}
                                      >
                                        Submit
                                      </LoadingButton>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12}>
                                    {loadingButton ? (
                                      <Box sx={{ textAlign: "center" }}>
                                        <Link sx={{ color: "#d3d3d3" }}>
                                          Back to Sign in
                                        </Link>
                                      </Box>
                                    ) : (
                                      <Box
                                        sx={{ textAlign: "center" }}
                                        onClick={() => {
                                          // setShowEmail(false);
                                          // setShowOtp(false);
                                          // setHeaderText("Sign In With");
                                          // reset("");
                                        }}
                                      >
                                        <Link
                                          disabled={loadingButton}
                                          sx={{ cursor: "pointer" }}
                                        >
                                          Back to Sign in
                                        </Link>
                                      </Box>
                                    )}
                                  </Grid>
                                </Grid>
                              </motion.div>
                            </>
                          ) : (
                            <>
                              <motion.div>
                                <FormProvider {...methods}>
                                  <form
                                    id="sign-in"
                                    onSubmit={handleSubmit(handleSubmitCustom)}
                                  >
                                    <Grid
                                      container
                                      spacing={2}
                                      justifyContent="center"
                                    >
                                      <Grid
                                        item
                                        xs={10}
                                        sm={12}
                                        md={12}
                                        sx={{ paddingLeft: "0px !important" }}
                                      >
                                        <FormLabel
                                          sx={{
                                            fontSize: {
                                              xs: "20px",
                                              sm: "22px",
                                            },
                                            fontWeight: 700,
                                            lineHeight: "42px",
                                            color: "#FDF9E0",
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <MailIcon
                                            sx={{
                                              fontSize: "large",
                                              width: "25px",
                                              height: "25px",
                                              marginRight: "5px",
                                            }}
                                          />
                                          Email
                                        </FormLabel>
                                        <Controller
                                          control={control}
                                          name={"email"}
                                          rules={{
                                            required:
                                              "Email Address is required",
                                            pattern: {
                                              value:
                                                /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                                              message:
                                                "Oh no, that doesn't look like a valid email! Please double-check and try again.",
                                            },
                                          }}
                                          render={({ field }) => (
                                            <TextField
                                              {...field}
                                              error={
                                                errors?.email ? true : false
                                              }
                                              id="email"
                                              label={EMAIL_GHOST_TEXT}
                                              fullWidth
                                              required
                                              sx={{
                                                "& .MuiOutlinedInput-root": {
                                                  backgroundColor:
                                                    "transparent !important", // Background color
                                                  "& fieldset": {
                                                    borderColor: "#FFFFFF", // Default border color
                                                  },
                                                  "&:hover fieldset": {
                                                    borderColor: "#FDF9E0", // Border color on hover
                                                  },
                                                  "&.Mui-focused fieldset": {
                                                    borderColor: "#FDF9E0", // Border color when focused
                                                  },
                                                },
                                                "& .MuiInputLabel-root": {
                                                  color: "#fff", // Label color
                                                },
                                                "& .MuiInputLabel-root.Mui-focused":
                                                  {
                                                    color: "#26801E", // Label color when focused
                                                  },
                                                "& .MuiInputBase-input": {
                                                  color: "#fff", // Input text color
                                                },
                                              }}
                                              type="email"
                                              helperText={
                                                <>
                                                  {errors?.email &&
                                                    errors?.email.message}
                                                  {errors?.email &&
                                                    errors.type ===
                                                      "validomain"?.email
                                                        ?.message}
                                                </>
                                              }
                                            />
                                          )}
                                        />
                                      </Grid>
                                      <Grid item xs={8} md={4} lg={4}>
                                        <Box>
                                          <LoadingButton
                                            variant="contained"
                                            size={"medium "}
                                            form="sign-in"
                                            fullWidth
                                            type="submit"
                                            sx={{
                                              borderRadius: "10px",
                                              "&.Mui-disabled": {
                                                color: "#333",
                                                borderColor: "#333",
                                              },
                                              color: "#FDF9E0",
                                            }}
                                            loading={loadingButton}
                                          >
                                            GET OTP
                                          </LoadingButton>
                                        </Box>
                                      </Grid>
                                      <Grid
                                        item
                                        xs={12}
                                        sx={{ pl: "0px !important" }}
                                      >
                                        {loadingButton ? (
                                          <Box sx={{ textAlign: "center" }}>
                                            <Link sx={{ color: "#d3d3d3" }}>
                                              Back to Sign in
                                            </Link>
                                          </Box>
                                        ) : (
                                          <Box
                                            sx={{ textAlign: "center" }}
                                            onClick={() => {
                                              setShowEmail(false);
                                              setShowOtp(false);
                                              setHeaderText("Sign In With");
                                              reset("");
                                            }}
                                          >
                                            <Link
                                              disabled={loadingButton}
                                              sx={{ cursor: "pointer" }}
                                            >
                                              Back to Sign in
                                            </Link>
                                          </Box>
                                        )}
                                      </Grid>
                                    </Grid>
                                  </form>
                                </FormProvider>
                              </motion.div>
                            </>
                          )}
                        </Grid>
                        {errorMessage && (
                          <Typography
                            variant="body2"
                            color="error"
                            sx={{ textAlign: "center", mt: 2 }}
                          >
                            {errorMessage}
                          </Typography>
                        )}
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          borderRadius: "20px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: {
                            xs: "center",
                            md: "center",
                            lg: "center",
                          },
                          flexDirection: "column",
                          maxWidth: { xs: 281, sm: 499 },
                          width: "100%",
                          background: "#231F20",
                          margin: "0 auto",
                          p: { xs: "16px", md: "30px" },
                        }}
                        component="form"
                        onSubmit={handleSubmit(handleOTPSubmit)}
                      >
                        <Typography
                          sx={{
                            fontSize: "32px",
                            fontFamily: "Kanit",
                            color: "#FDF9E0",
                            fontWeight: { xs: 600, md: 700 },
                            mb: "10px",
                          }}
                          textAlign={"center"}
                        >
                          Enter the OTP
                        </Typography>
                        <Alert
                          icon={false}
                          severity="success"
                          sx={{ justifyContent: "center", mb: "37px" }}
                        >
                          {/* Received in the email sent to your email id */}
                          We’ve sent a verification code to your E-mail
                        </Alert>

                        <Controller
                          name="otp"
                          control={control}
                          rules={{
                            required: "OTP is required",
                            pattern: {
                              value: /^[0-9]+$/,
                              message: OTP_ERROR_MSG,
                            },
                          }}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              error={errors?.otp ? true : false}
                              fullWidth
                              id="otp"
                              type="number"
                              label={OTP_GHOST_TEXT}
                              helperText={
                                <>{errors?.otp && errors?.otp.message}</>
                              }
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "transparent", // Background color
                                  "& fieldset": {
                                    borderColor: "#fff", // Default border color
                                  },
                                  "&:hover fieldset": {
                                    borderColor: "#fff", // Border color on hover
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: "#fff", // Border color when focused
                                  },
                                },
                                "& .MuiInputLabel-root": {
                                  color: "#ffff", // Label color
                                },
                                "& .MuiInputLabel-root.Mui-focused": {
                                  color: "#fff", // Label color when focused
                                },
                                "& .MuiInputBase-input": {
                                  color: "#fff", // Input text color
                                },
                              }}
                            />
                          )}
                        />
                        <Box alignItems={"center"} textAlign="center">
                          <LoadingButton
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{
                              mt: 4,
                              mb: 2,
                              borderRadius: "10px",
                              "&.Mui-disabled": {
                                color: "#333",
                                borderColor: "#333",
                              },
                              color: "#FDF9E0",
                            }}
                            loading={loadingButton}
                          >
                            Submit
                          </LoadingButton>
                          <Link
                            href="/signin"
                            color="primary"
                            fontSize="small"
                            textAlign={"center"}
                          >
                            Back to Sign in
                          </Link>
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Grid>
              </Grid>
            ) : (
              <Grid
                container
                spacing={2}
                sx={{
                  height: "100%",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: showOTPForm ? "top" : "center",
                  p: { xs: 2, md: 4 },
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* Logo Section */}
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: { xs: "center", lg: "center" },
                      pt: 3,
                      width: "100%",
                    }}
                  >
                    <a href="/">
                      <img
                        src={"../../assets/images/TrueSelfy-logo.svg"}
                        alt="true-selfy"
                        style={{
                          maxWidth: isMobile ? "80px" : "150px",
                        }}
                        loading="lazy"
                      />
                    </a>
                  </Box>
                </Grid>

                {/* Message Section */}
                <Grid item xs={12}>
                  <Box
                    sx={{
                      pt: 3,
                      textAlign: "center",
                    }}
                  >
                    <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                      Access Restricted
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Unfortunately, access to this site is currently limited.
                      We apologize for any inconvenience
                    </Typography>
                    <Typography variant="body2">
                      Thank you for visiting. If you have any questions or
                      require assistance, please contact our support team.
                    </Typography>
                  </Box>
                  <Box sx={{ textAlign: "center", pt: 2 }}>
                    <Link
                      color="inherit"
                      href={`${process.env.REACT_APP_BASE_URL}/contact-us`}
                      sx={{ cursor: "pointer" }}
                    >
                      Contact support
                    </Link>
                  </Box>
                </Grid>

                {/* Return Button */}
                <Grid item xs={12} sx={{ textAlign: "center", mt: 1 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    href="/"
                    sx={{ mt: 1 }}
                  >
                    Go Back to Home
                  </Button>
                </Grid>
              </Grid>
            )}
          </Box>
        </>
      )}
    </>
  );
}
